import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';
import { MaybeBoolSelect } from 'Views/Page/Content/Modal/Layouts/JobBasicInformationStep/Layout/MaybeBoolSelect';

export default buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly)
  .nameOverride('subtitle', { _component: () => BodyTextMedium }, overrideReadOnly)
  .nameOverride(['startType', 'endType'], {
    _component: () => MaybeBoolSelect,
  }, overrideReadOnly);
